import { TwitterAuthProvider, signInWithPopup } from 'firebase/auth'
import { auth } from '../firebase'

const provider = new TwitterAuthProvider()

export async function signInWithX() {
    const result = await signInWithPopup(auth, provider)
    console.log(result)
}
